import Vue from 'vue'
import Vuex from 'vuex'
import tools from '@/tools/tools'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // url 渠道参数，由页面参数获取
    channelInfo: {
      // 是否获取过渠道参数
      isload: false,
      sub: '',
      mark: ''
    },
    configs: {
      // 是否开启 openInstall
      openInstall: {
        isOpen: false,
        apps: {
          // 千分扑克
          qfpk: {
            AppKey: 'tvsikf'
          }
          // 其它
        }
      },
      // 小程序 url
      wxMiniGameUrl: {
        // 官网默认 main,main
        default: 'https://wxaurl.cn/Epn1S4cIgwq',
        // 千分扑克
        qfpk: {
          // 官网默认 main,main
          default: 'https://wxaurl.cn/Epn1S4cIgwq',
          // 海南合赛（）
          hnhs: {
            // 欢乐节暨“大掼蛋杯” hnhs,hlj
            hlj: 'https://wxaurl.cn/U0TOvJBbVco'
          }
        }
      },
      download: {
        // 千分扑克
        qfpk: {
          // 安卓apk下载链接
          apk: 'https://lbyx.net/down/pag/apk/wuyou_puke_20260323.apk',
          ipa: 'https://lbyx.net/down/pag/xxx.plist',
          // 苹果商店跳转链接
          appStore: 'https://apps.apple.com/cn/app/%E6%97%A0%E6%82%A0%E5%8D%83%E5%88%86%E6%89%91%E5%85%8B/id6477151347',
          superIpa: 'https://xxx.xxx.xx',
          iosTips: require('@/assets/xxx.png'),
          iosPic: require('@/assets/xxx.png')
        }
      },
      huodongs: [],
      news: [],
      kefus: [
        {
          name: '无悠千分扑克',
          type: '公众号',
          code: '无悠网络',
          img: require('@/assets/kefuvx_01.png')
        }
      ],
      company: {
        main: '吉林省无悠网络科技有限公司',
        mainEN: '',
        name: '',
        nameEN: '',
        team: '无悠网络',
        address: '长春市净月开发区君盈身份广场1号楼411室',
        telephone: '18907592233',
        Postcode: '130022',
        wangwen: '经营许可证：吉B2-20170176',
        appBei: '无悠千分扑克：吉ICP备2020006778号-4A',
        IPC: '吉ICP备2020006778号-2',
        banhao: '批号：新广出审[2018]888号 ISBN 978-7-498-04293-4',
        gonganBeian: '吉ICP备2020006778号-1',
        zhongxuanbu: '1104028402'
      },
      // 子游戏列表
      allGames: [
        {
          title: '扑克',
          en: 'POKER',
          type: 'list',
          list: [
            {
              title: '无悠千分扑克',
              ico: '/static/game/ico/wuyou_qianfen.png',
              text: '集全国各地多种知名扑克玩法。斗地主、跑得快、掼蛋、升级、千分等，更多玩法陆续推出。真人对战、多人比赛，好友同玩，天天送豆！',
              type: 'app',
              // 给 ios 备用，没有 app 的时候 跳到 h5
              h5Url: 'https://h5.lbyx.net/',
              downKey: 'qfpk'
            }, {
              // 跳转H5
              title: '无悠千分扑克',
              ico: '/static/game/ico/wuyou_qianfen.png',
              text: '集全国各地多种知名扑克玩法。斗地主、跑得快、掼蛋、升级、千分等，更多玩法陆续推出。真人对战、多人比赛，好友同玩，天天送豆！',
              type: 'h5',
              h5Url: 'https://h5.lbyx.net/',
              downKey: 'qfpk'
            }, {
              title: '无悠掼蛋',
              ico: '/static/game/ico/wuyou_qianfen.png',
              text: '资深掼蛋玩家聚集地! 饭前不掼蛋,等于没吃饭! 掼蛋游戏的玩法简单,娱乐性强,是休闲娱乐的首选棋牌游戏。',
              type: 'app',
              // 给 ios 备用，没有 app 的时候 跳到 h5
              h5Url: 'https://h5.lbyx.net/',
              downKey: 'qfpk'
            }, {
              title: '无悠升级',
              ico: '/static/game/ico/wuyou_shengji.png',
              text: '快来升级吧，就等你啦。',
              type: 'app',
              // 给 ios 备用，没有 app 的时候 跳到 h5
              h5Url: 'https://h5.lbyx.net/',
              downKey: 'qfpk'
            }, 
            {
              title: '无悠千分510K',
              ico: '/static/game/ico/wuyou_qianfen510k.png',
              text: '游戏紧张刺激，斗智斗勇，看谁能笑到最后',
              type: 'app',
              // 给 ios 备用，没有 app 的时候 跳到 h5
              h5Url: 'https://h5.lbyx.net/',
              downKey: 'qfpk'
            }, 
            {
              title: '无悠斗地主',
              ico: '/static/game/ico/wuyou_ddz.png',
              text: '斗地主啦，斗地主玩法简单上手轻松玩！老少皆宜，游戏紧张刺激，考验玩家的智慧与勇气的游戏。',
              type: 'app',
              // 给 ios 备用，没有 app 的时候 跳到 h5
              h5Url: 'https://h5.lbyx.net/',
              downKey: 'qfpk'
            }, {
              title: '无悠跑得快',
              ico: '/static/game/ico/wuyou_pdk.png',
              text: '轻松解压，玩法规则超级简单，玩家只需要在游戏中将自己手中的牌尽快出完即可，画面清新简约易上手。',
              type: 'app',
              // 给 ios 备用，没有 app 的时候 跳到 h5
              h5Url: 'https://h5.lbyx.net/',
              downKey: 'qfpk'
            }, {
              title: '无悠千分扑克（微信小程序）',
              ico: '/static/game/ico/wuyou_qianfen.png',
              text: '集全国各地多种知名扑克玩法。斗地主、跑得快、掼蛋、保皇、够级等，更多玩法陆续推出。真人对战、多人比赛，好友同玩，天天送豆！',
              type: 'xcx',
              downKey: 'qfpk'
            }
          ]
        }, {
          title: '麻将',
          en: 'MAHLONG',
          // type: 'sub',
          type: 'list',
          list: [{
            title: '无悠麻将',
            ico: '/static/game/ico/wuyou_majiang.png',
            text: '《无悠麻将》集合全国各地麻将玩法，即将推出！',
            downKey: 'majiang'
          }]
        }
      ],
      games: [
        {
          name: '无悠千分扑克',
          type: 'mj',
          homeImg: require('@/assets/game/qianfen.jpg'),
          title: '',
          text: '《无悠千分扑克》集全国各地多种知名扑克玩法。斗地主、跑得快、掼蛋、保皇、够级等，更多玩法陆续推出。真人对战、多人比赛，好友同玩，天天送豆！',
          appName: '无悠千分扑克',
          appText: '国内知名扑克玩法，千万用户的日常休闲娱乐游戏，不玩你就落伍了，赶快下载吧！',
          tips: '手痒了想，来《无悠千分扑克》，技痒了也来《无悠千分扑克》，更有比赛功能，即使相隔天南海北也能零距体验竞技乐趣。',
          h5Url: 'https://h5.lbyx.net/',
          downKey: 'qfpk'
        }
      ],
      // 轮播数据
      swiperData: {
        time: 6000,
        space: '0.5s',
        backgroundSizeImg: require('@/assets/mobile/banners/bbsi.png'),
        foregroundSizeImg: require('@/assets/mobile/banners/banner_bg.png'),
        textImg: require('@/assets/mobile/swiper_text_img.png'),
        dotStyles: { bottom: '1rem' },
        textStyles: { bottom: '2rem' },
        textImgStyles: { bottom: '4rem', width: '6rem' },
        list: [{
          code: '1',
          img: require('@/assets/mobile/banners/banner1.jpg'),
          title: '无悠千分扑克',
          titleSub: '',
          tipe: '致力于做全国性的扑克类手机游戏。精美画风，超多活动福利倾囊相赠！精彩游戏，尽在无悠千分扑克！',
          exData: ''
        }, {
          code: '2',
          img: require('@/assets/mobile/banners/banner2.jpg'),
          title: '比赛竞技',
          titleSub: '',
          tipe: '画风精致，手感流畅，大品牌稳定运营，更有比赛功能可供亲朋好友一起玩耍。精彩游戏，尽在无悠千分扑克！',
          exData: ''
        }, {
          code: '3',
          img: require('@/assets/mobile/banners/banner3.jpg'),
          title: '掼蛋',
          titleSub: '',
          tipe: '资深掼蛋玩家聚集地! 饭前不掼蛋,等于没吃饭! 掼蛋游戏的玩法简单,娱乐性强,是休闲娱乐的首选棋牌游戏。尽在无悠千分扑克！',
          exData: ''
        }]
      },
      // 轮播数据PC
      swiperData_pc: {
        time: 6000,
        space: '0.5s',
        backgroundSizeImg: require('@/assets/pc/banners/bbsi.png'),
        foregroundSizeImg: require('@/assets/pc/banners/banner_bg.png'),
        textImg: require('@/assets/mobile/swiper_text_img.png'),
        dotStyles: { bottom: '4rem', right: '6rem' },
        textStyles: { bottom: '11rem', left: '5rem' },
        textImgStyles: { bottom: '8rem', left: '5rem', width: '6rem' },
        list: [{
          code: '1',
          img: require('@/assets/pc/banners/banner1.jpg'),
          title: '无悠千分扑克',
          titleSub: '',
          tipe: '致力于做全国性的扑克类手机游戏。精美画风，超多活动福利倾囊相赠！精彩游戏，尽在无悠千分扑克！',
          exData: ''
        }, {
          code: '2',
          img: require('@/assets/pc/banners/banner2.jpg'),
          title: '比赛竞技',
          titleSub: '',
          tipe: '画风精致，手感流畅，大品牌稳定运营，更有比赛功能可供亲朋好友一起玩耍。精彩游戏，尽在无悠千分扑克！',
          exData: ''
        }, {
          code: '3',
          img: require('@/assets/pc/banners/banner3.jpg'),
          title: '掼蛋',
          titleSub: '',
          tipe: '资深掼蛋玩家聚集地! 饭前不掼蛋,等于没吃饭! 掼蛋游戏的玩法简单,娱乐性强,是休闲娱乐的首选棋牌游戏。尽在无悠千分扑克！',
          exData: ''
        }]
      }
    }
  },
  getters: {
    // openinstall 是否开启
    openInstallIsOpen: (state) => {
      return state.configs.openInstall.isOpen
    },
    // 从 url 参数中 获取渠道信息
    getChannelInfo: (state) => {
      if (!state.channelInfo.isload) {
        state.channelInfo.isload = true
        state.channelInfo.sub = tools.getUrlParam('sub')
        state.channelInfo.mark = tools.getUrlParam('mark')
        console.log(state.channelInfo)
      }
      return state.channelInfo
    },
    // 获取渠道信息 url 参数字符串
    getChannelInfoStr: (state, getters) => {
      const info = getters.getChannelInfo
      const out = {}
      if (info.sub) {
        out.sub = info.sub
      }
      if (info.mark) {
        out.mark = info.mark
      }
      return tools.objToParam(out)
    },
    // 获取小程序 url
    getMiniGameUrl: (state, getters) => (vid) => {
      const channelInfo = getters.getChannelInfo
      let config = state.configs.wxMiniGameUrl
      // 一层一层的找，找不到就用默认
      let goConfig = config[vid]
      // 没有这个游戏 就返回默认
      let backUrl = config.default
      if (!goConfig) {
        return backUrl
      }
      config = goConfig

      // 没有子渠道信息 就返回默认
      goConfig = config[channelInfo.sub]
      backUrl = config.default
      if (!goConfig) {
        return backUrl
      }
      config = goConfig

      // 有渠道标识就返回
      goConfig = config[channelInfo.mark]
      if (goConfig) {
        return goConfig
      }

      // 没有就返回默认
      return backUrl
    },
    // 获取apk下载
    getDownApk: (state) => (vid) => {
      return state.configs.download[vid].apk
    },
    // 获取ipa下载
    getDownIos: (state) => (vid) => {
      const url = 'itms-services:///?action=download-manifest&url='
      return url + state.configs.download[vid].ipa
    },
    // 获取根据平台选择下载
    getDownNow: (state) => (vid) => {
      const isIos = tools.isIOS()
      if (isIos) {
        return state.configs.download[vid].appStore
      }
      return state.configs.download[vid].apk
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
